let label;
let description;

export default {
    size: {
        key: 'size',
        keyLabel: 'size',
        label: 'Size',
        choices: [
            {
                label: (label = '4.0625”d × 4”h'),
                detailsModalLabel: label,
                value: '4.0625-x-4',
                description: (description =
                    'Approximately 6–8 oz *Fill testing recommended'),
                detailsModalDescription: description,
            },
            {
                label: (label = '4.0625”d × 5.5”h'),
                detailsModalLabel: label,
                value: '4.0625-x-5.5',
                description: (description =
                    'Approximately 8–12 oz *Fill testing recommended'),
                detailsModalDescription: description,
            },
            {
                label: (label = '4.0625”d × 7”h'),
                detailsModalLabel: label,
                value: '4.0625-x-7',
                description: (description =
                    'Approximately 10–16 oz *Fill testing recommended'),
                detailsModalDescription: description,
            },
        ],
        detailsModalLabel: 'Size options:',
    },
};
